module.exports = __webpack_public_path__ + "static/media/icon_step2.6990ee54.png";